import config from '../config/configureEnv';
import { ajax, getUserAuthDataFromLocalStorage } from '../utils';

export default {
  getTeamMembers: () => {
    const userAuthData = getUserAuthDataFromLocalStorage();
    const { accessToken } = userAuthData;

    return ajax('GET', `${config.bocaAPIUrl}/users/teamMembers`, {
      urlParams: { access_token: accessToken },
    });
  },

  deleteMember: (teamId, memberId) => {
    const { accessToken } = getUserAuthDataFromLocalStorage();

    return ajax('POST', `${config.bocaAPIUrl}/teams/${teamId}/deleteMember/${memberId}`, {
      urlParams: { access_token: accessToken },
    });
  },

  subscribe: (planKey) => {
    const { accessToken } = getUserAuthDataFromLocalStorage();

    return ajax('POST', `${config.bocaAPIUrl}/subscriptions/subscribe`, {
      urlParams: { access_token: accessToken },
      data: JSON.stringify({ planKey }),
    });
  },

  getPendingSubscriptions: () => {
    const { accessToken } = getUserAuthDataFromLocalStorage();

    return ajax('GET', `${config.bocaAPIUrl}/subscriptions/pending`, {
      urlParams: { access_token: accessToken },
    });
  },

  approveSubscription: (id) => {
    const { accessToken } = getUserAuthDataFromLocalStorage();

    return ajax('GET', `${config.bocaAPIUrl}/subscriptions/${id}/approve`, {
      urlParams: { access_token: accessToken },
    });
  },

  declineSubscription: (id) => {
    const { accessToken } = getUserAuthDataFromLocalStorage();

    return ajax('GET', `${config.bocaAPIUrl}/subscriptions/${id}/decline`, {
      urlParams: { access_token: accessToken },
    });
  },

  getPaymentHistory: (teamId) => {
    const { accessToken } = getUserAuthDataFromLocalStorage();

    return ajax('GET', `${config.bocaAPIUrl}/teams/${teamId}/payments`, {
      urlParams: { access_token: accessToken },
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/TeamAPIConnectors.js